import React, { useEffect } from "react";
import { makeStyles } from '@material-ui/core/styles';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

const useStyles = makeStyles((theme) => ({
    pagination: {
        background: "#F6F6F6",
        height: "40px",
        position: "fixed",
        bottom: 0,
        width: '100%',
        color: "#000000",
        fontWeight: "bold",
        margin: "auto",
    },
    paginationItem: {
        float: "right",
        marginRight: "13px",
        marginTop: "11px",
    },
    arrow: {
        fontSize: "15px",
        color: "#000000",
        cursor: "pointer"
    }
}));

const Pagination = () => {
    const classes = useStyles();

    return (
        <>
            <div className={`${classes.pagination} `}>
                <div className={classes.paginationItem}>
                    <ArrowBackIcon className={classes.arrow} />
                    <span className="pl-2 pr-2">Page 1</span>
                    <ArrowForwardIcon className={classes.arrow} />
                </div>
            </div>
        </>
    );
}
export default Pagination;

